import { render } from "./Registration.vue?vue&type=template&id=a8627510&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=a8627510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8627510"]])

export default __exports__